import { RiTeamLine, RiBuildingLine, RiBankLine, RiBriefcase3Line, RiSettings4Line } from 'react-icons/ri'

import SmallSideBarItem from './SmallSideBarItem/SmallSideBarItem';

import './SideBar.css';
import { useSelector } from 'react-redux';

function SideBar() {

    const {employee} = useSelector(state => state.auth)

    return (
        <>
            <section className="small_sidebar">
                <div className='container'>

                    <SmallSideBarItem link={'/'}>
                        {<RiBuildingLine />}
                    </SmallSideBarItem>

                    <SmallSideBarItem link={'/organizations'}>
                        {<RiBankLine />}
                    </SmallSideBarItem>

                    {(employee.level === 'admin' || employee.level === 'superAdmin') &&
                    <>
                        <SmallSideBarItem link={'/organizationGroups'}>
                            {<RiBriefcase3Line />}
                        </SmallSideBarItem>
                    

                        <SmallSideBarItem link={'/user_screens'}>
                            {<RiTeamLine />}
                        </SmallSideBarItem>

                        <SmallSideBarItem link={'/websiteContents'}>
                            {<RiSettings4Line />}
                        </SmallSideBarItem>
                    </>
                    }


                </div>
            </section>
        </>
    )
}

export default SideBar
